import { config } from "../../config";

const baseApiUrl = config.apiUri;

export const buildUrl = (path: string) => {
    return `${baseApiUrl}${path}`;
};